import React from "react";
import { useEffect, useState, useRef } from "react";
import "../assets/styles/Images.scss";
import { Image } from "react-bootstrap";
import ImageModal from "./ImageModal";
import faiedimg from "../assets/Images/Load image.jpg";
import { poleReplacementType } from "../types/customTypes";
import { CloudArrowUp } from "react-bootstrap-icons";
import { getPoleImages, uploadImageAPi } from "../services/api";
import { toast } from "react-toastify";
import { getRole } from "../services/authenticationService";

type images = {
	url: string;
	imgName: string;
	priority: string;
	isDelete: boolean;
};

type imageFiles = {
	imgName: string;
	priority: string;
};

type replacementHistoryArray = {
	categoryId: number;
	repairId: number;
	repairCategoryId: number
	updatedOn: string;
	updatedBy: string;
	isResolved: boolean;
	isUpdateable: boolean;
	category: string;
	subCategory: string;
	repairDescription: string;
};

export interface Props {
	images: images[];
	imageLoaded: () => void;
	poleid: unknown | string;
	isloading: boolean;
	imageFiles: imageFiles[];
	highPriority: number[];
	replacementHistory: replacementHistoryArray[];
	isPoleReplacement: poleReplacementType;
	refreshPoleData: () => void;
}

const Images: React.FC<Props> = (props: Props) => {
	const [modalShow, setModalShow] = useState(false);
	const [showUploadImageDiv, setShowUploadImageDiv] = useState(false);
	const [image, setImage] = useState({ name: '' });
	const [imagesData, setImagesData] = useState([]);
	const [imagesUrls, setImagesUrls] = useState({});
	const [activeImages, setActiveImages] = useState([]);
	const [deletedImages, setDeletedImage] = useState([]);
	const [isLoadingImg, setIsLoadingImg] = useState({deleted: 0, active: 0});
	const [selectedFiles, setSelectedFiles] = useState([]);
	const myRef = useRef(null);

	const handleFileChange = (event) => {
		const files: FileList | null = event.target.files;
		if (files && files.length > 0) {
			const allowedFileTypes = ["image/png", "image/jpeg", "image/jpg", "image/heic", "image/webp", "image/svg"];
			const validFiles = Array.from(files).filter(
				(file: File) => (allowedFileTypes.includes(file.type))
			);
			if (validFiles.length < files.length) toast.warn("Please select a valid image format (e.g., JPEG, PNG..)")
			setSelectedFiles(validFiles.length > 0 ? (selectedFiles === null ? validFiles : [...selectedFiles, ...validFiles]) : selectedFiles);
			event.target.value = "";
		}
	};

	useEffect(() => {
		setActiveImages(imagesData.filter(img => !img.isDelete));
		setDeletedImage(imagesData.filter(img => img.isDelete));
	}, [imagesData]);

	useEffect(() => {
		callImageAPi();
		setImagesData(props.images);
	}, [props.images]);

	/* istanbul ignore next  */
	const resetImages = (Priority, imagename) => {  // call when priority get changed
		imagesData.find(({ imageName }) => imageName === imagename).priority = Priority;  //adding priority to image and replacing that object
		imagesData.sort((a) => (a.priority === 'high') ? -1 : 1)  //sort images by high priority
		//Scroll to the top of the images list
		myRef.current.scrollIntoView();
	};

	const handleChange = (name, priority, isDelete) => {  //To show image modal and store img object
		setModalShow(true)
		const obj = { name, priority, isDelete }
		setImage(obj);
	};

	const callImageAPi = () => {
		for (const img of props.images) { 
			getPoleImages(props.poleid, img.imgName, false).then(image => { 
				image.blob().then((blob) => { 
					const file = new Blob([blob]);
					imagesUrls[img.imgName] = window.URL.createObjectURL(file);
					setImagesUrls({...imagesUrls });
				});
			}).catch(err => {
				console.error(err);
			})
		}
	};

	const renderImages = () => {
		if (activeImages.length > 0)
			return (
				<>
					{activeImages.map((img, index) => (
						<div key={index}>
							<div className="d-flex bd-highlight mb-2" data-testid="imgContainer">
								{imagesUrls[img.imgName] ? 
									<Image
										className={`image-box ${img.priority === 'high' ? 'border border-danger border-3' : ''}`}
										data-testid="img"
										src={imagesUrls[img.imgName]}
										onLoad={() => setIsLoadingImg({...isLoadingImg, active: isLoadingImg.active+1})}
										onClick={() => handleChange(img.imgName, img.priority, img.isDelete)}
									/> : (isLoadingImg.active === activeImages.length && renderFailedImage())
								}
							</div>
						</div>
					))}
					
				</>
			)
		else
			return (
				<div className="alert alert-warning alert-dismissible fade show mt-2" data-testid="alert-1" role="alert">
					No Images to show.
				</div>
			)
	};

	const renderDeletedImages = () => {
		if (deletedImages.length > 0)
			return (
				<>
					{deletedImages.map((img, index) => (
						<div className="d-flex bd-highlight mb-2" key={index} data-testid="imgContainer">
							{imagesUrls[img.imgName] ? 
								<Image
									className={`image-box ${img.priority === 'high' ? 'border border-danger border-3' : ''}`}
									data-testid="img"
									src={imagesUrls[img.imgName]}
									onLoad={() => setIsLoadingImg({...isLoadingImg, deleted: isLoadingImg.deleted+1})}
									onClick={() => handleChange(img.imgName, img.priority, img.isDelete)}
								/> : (isLoadingImg.deleted === deletedImages.length && renderFailedImage())
							}
						</div>
					))}
				</>
			)
		else
			return (
				<div className="alert alert-warning alert-dismissible fade show mt-2" data-testid="alert-1" role="alert">
					No Images to show.
				</div>
			)
	};

	const renderFailedImage = () => {
		return (
			<div>
				<div className='image-container d-flex align-items-center justify-content-center mb-2' data-testid="failedimg">
					<Image id="img" src={faiedimg} alt="" />
				</div>
			</div>
		);
	};

	const handleDragOver = (event) => {
		event.preventDefault();
	};

	const handleDragEnter = (event) => {
		event.preventDefault();
	};

	const handleDragLeave = (event) => {
		event.preventDefault();
	};

	const handleDrop = (event) => {
		event.preventDefault();
		const files = event.dataTransfer.files;
		// Convert the FileList object to an array
		const filesArray = Array.from(files);
		setSelectedFiles(filesArray);
	};

	const uploadImages = () => {
		const promises = selectedFiles.map(file => {
			return uploadImageAPi(props.poleid, file);
		});

		Promise.all(promises).then(responses => {
			props.refreshPoleData();
			responses.forEach(response => {
				if (response.status === 200) {
					setSelectedFiles([]);
					toast.success('Images Uploaded Successfully!');
					console.log('Image uploaded successfully:', response);
				} if(response.status === 500){
					toast.warn("The image is already exists");
				}else {
					console.warn('Unexpected status code:', response.status);
				}
			});
		}).catch(error => {
			console.error(error);
			toast.error('Failed to upload!', );
		});
	};

	const renderSpinner = () => {
		return (
			<div className="d-flex justify-content-center mt-5" data-testid="loader">
				<div className="spinner-border" role="status">
					<span className="visually-hidden" >Loading...</span>
				</div>
			</div>
		);
	};

	const markImageDeleted = (archivedImageName) => {
		const archivedImage = imagesData.find(img => img.imgName === archivedImageName);
		archivedImage.isDelete = !archivedImage.isDelete;
		setImagesData([...imagesData]);
	};

	const renderUploadImageButton = () => {
		return (
			<div>
				<button type="button" className="d-flex bd-highlight mb-2 btn btn-link float-end shadow-none" data-testid="uploadImageBtn" style={{ fontSize: 'small'}} onClick={() => {setShowUploadImageDiv(!showUploadImageDiv); setSelectedFiles([])}}>Upload Image</button>
			</div>
		);
	};

	const renderUploadImageDiv = () => {
		return (
			<>
				<span>Upload Images for Pole</span>
				<div
					id="drop-area"
					className="bg-light mt-2 mb-2 border rounded d-flex justify-content-center align-items-center"
					onDragOver={handleDragOver}
					onDragEnter={handleDragEnter}
					onDragLeave={handleDragLeave}
					onDrop={handleDrop}
				>
					<div className="text-center pointer">
						<CloudArrowUp size="24" color="skyblue" className="mt-2" />
						<p className="mt-2 text-secondary">Drag and drop your files here or <label htmlFor="fileElem" className="text-decoration-underline pointer">upload an image</label>.</p>
					</div>
				</div>
				<input type="file" id="fileElem" multiple accept="image/png, image/jpeg, image/jpg, image/heic, image/webp, image/svg" className="d-none" onChange={handleFileChange} />
				<p className="text-muted fw-light mb-1">Number of images selected to upload: {selectedFiles.length}</p>
				<div className="mt-2 mb-3 d-flex justify-content-center align-items-center gap-4">
					<button type="reset" className="btn btn-light border" style={{ fontSize: 'small'}} onClick={() => {setShowUploadImageDiv(!showUploadImageDiv); setSelectedFiles([])}}>Cancel</button>
					<button type="submit" className="btn btn-primary" style={{ fontSize: 'small'}} disabled={selectedFiles.length === 0} onClick={uploadImages}>Upload</button>
				</div>
			</>
		)
	};

	return (
		<div className="images h-100p" id="images">
			<div className="d-flex flex-column bd-highlight me-1 h-100p" ref={myRef}>
				{(!props.poleid) ?
					<div className="alert alert-warning alert-dismissible fade show mt-2" data-testid="alert-1" role="alert">
						Please select pole marker to view pole images.
					</div>
					: <div className="accordion" id="accordionPanelsStayOpenExample" style={{ fontSize: 'smaller', height: '100%' }}>
						<div className="accordion-item h-50p">
							<h2 className="accordion-header" id="panelsStayOpen-headingOne">
								<button className="accordion-button p-2 border-bottom" style={{ fontSize: 'small'}} type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
									Active Images
								</button>
							</h2>
							<div id="panelsStayOpen-collapseOne" style={{ overflowY: 'auto' }} className="h-80p accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
								<div className="accordion-body p-2">
									<div className="d-flex justify-content-end mb-2">
										{(getRole() === 'Admin' || getRole() === 'Maintainer')  && renderUploadImageButton()}
									</div>
									<>
										{showUploadImageDiv && renderUploadImageDiv()}
										{renderImages()}
										{isLoadingImg.active < activeImages.length && renderSpinner()}
									</>

								</div>
							</div>
						</div>
						<div className="accordion-item h-50p">
							<h2 className="accordion-header" id="panelsStayOpen-headingTwo">
								<button className="accordion-button collapsed p-2 border-bottom" style={{ fontSize: 'small'}} type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
									Archived Images
								</button>
							</h2>
							<div id="panelsStayOpen-collapseTwo" style={{ overflowY: 'auto' }} className="h-80p accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
								<div className="accordion-body p-2">
									{renderDeletedImages()}
									{isLoadingImg.deleted < deletedImages.length && renderSpinner()}
								</div>
							</div>
						</div>
					</div>
				}
			</div>
			<ImageModal
				id={props.poleid}
				image={image}
				resetImages={resetImages}
				show={modalShow}
				onHide={() => setModalShow(false)}
				imageFiles={props.imageFiles}
				highPriority={props.highPriority}
				refreshPoleData={() => markImageDeleted(image.name)}
			/>

		</div>
	);
};

export default Images;
